import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 314px;
    padding: 32px 20px;
    border-radius: 8px;
    background-color: ${(props) => props.theme.palette.secondaryA10};

    @media (max-width: ${(props) => props.theme.breakPoints.md}) {
        width: 100%;
        background-color: ${(props) => props.theme.palette.primaryA7};
        min-height: 238px;
        padding: 16px 16px 0 16px;
        margin-top: 3px;
    }

    .card__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 120px;
        margin: 0 auto;

        @media (max-width: ${(props) => props.theme.breakPoints.md}) {
            max-width: 160px;
        }

        img {
            width: 100%;
            min-height: 98px;
            max-height: 98px;
            object-fit: contain;

            @media (max-width: ${(props) => props.theme.breakPoints.md}) {
                min-height: 120px;
                max-height: 120px;
            }
        }
    }

    .card__number {
        min-width: 40px;
        min-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px auto 0 auto;
        font-size: 20px;
        line-height: 30px;
        font-weight: 500;
        background-color: ${(props) => props.theme.palette.textMain};
        color: ${(props) => props.theme.palette.primaryA7};
        border-radius: 50%;

        @media (max-width: ${(props) => props.theme.breakPoints.md}) {
            display: none;
        }
    }

    .card__description {
        text-align: center;
        margin-top: 16px;

        @media (max-width: ${(props) => props.theme.breakPoints.md}) {
            font-size: 16px;
            line-height: 26px;
        }
    }
`;
